import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyCompany = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 300 300",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 102.36,
			cy: 98.84,
			r: 89.01,
			fill: "var(--primary)",
			fillOpacity: .16
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 216.8,
			height: 170.58,
			x: 67.2,
			y: 77.36,
			fill: "var(--foreground)",
			rx: 19.84,
			ry: 19.84,
			transform: "rotate(-79.38 175.6 162.65)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 33.34,
			height: 33.34,
			x: 233,
			y: 83.93,
			fill: "var(--card)",
			rx: 8.85,
			ry: 8.85,
			transform: "rotate(10.62 249.68 100.6)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M255.94 120.66q-1 0-2.03-.19l-15.38-2.88a10.94 10.94 0 0 1-8.73-12.75l2.89-15.38a11 11 0 0 1 4.57-7 11 11 0 0 1 8.18-1.73l15.37 2.89a10.94 10.94 0 0 1 8.73 12.75l-2.88 15.37a11 11 0 0 1-4.57 7 11 11 0 0 1-6.15 1.92M243.41 84.7a6.7 6.7 0 0 0-6.64 5.53l-2.88 15.37a6.8 6.8 0 0 0 5.4 7.9l15.38 2.89a6.73 6.73 0 0 0 7.9-5.41l2.89-15.38a6.8 6.8 0 0 0-5.41-7.9l-15.38-2.88a7 7 0 0 0-1.26-.12"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 33.34,
			height: 33.34,
			x: 224.35,
			y: 130.06,
			fill: "var(--card)",
			rx: 8.85,
			ry: 8.85,
			transform: "rotate(10.62 241.03 146.74)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M247.27 166.8q-1 0-2.01-.2l-15.38-2.88a11 11 0 0 1-7-4.57 11 11 0 0 1-1.73-8.18l2.89-15.38a11 11 0 0 1 4.57-7 11 11 0 0 1 8.18-1.72l15.38 2.88c2.87.54 5.35 2.16 7 4.57a11 11 0 0 1 1.72 8.18l-2.88 15.38a10.95 10.95 0 0 1-10.74 8.91Zm-1.25-4.28a6.8 6.8 0 0 0 7.9-5.4l2.89-15.38a6.7 6.7 0 0 0-1.07-5.08 6.7 6.7 0 0 0-4.34-2.83l-15.38-2.88a6.75 6.75 0 0 0-7.9 5.41l-2.88 15.37a6.73 6.73 0 0 0 5.4 7.9z"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 33.34,
			height: 33.34,
			x: 215.7,
			y: 176.2,
			fill: "var(--card)",
			rx: 8.85,
			ry: 8.85,
			transform: "rotate(10.62 232.39 192.88)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M238.65 212.93q-1.02 0-2.04-.2l-15.38-2.87a10.94 10.94 0 0 1-8.72-12.76l2.88-15.37a10.94 10.94 0 0 1 12.75-8.73l15.38 2.88a10.94 10.94 0 0 1 8.72 12.76L249.37 204a11 11 0 0 1-4.57 7 11 11 0 0 1-6.14 1.92Zm-12.52-35.96a6.8 6.8 0 0 0-6.66 5.52l-2.88 15.38a6.8 6.8 0 0 0 5.4 7.9l15.38 2.88a6.7 6.7 0 0 0 5.07-1.06 6.7 6.7 0 0 0 2.84-4.34l2.88-15.38a6.8 6.8 0 0 0-5.4-7.9l-15.38-2.89a7 7 0 0 0-1.25-.11"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 33.34,
			height: 33.34,
			x: 207.05,
			y: 222.33,
			fill: "var(--card)",
			rx: 8.85,
			ry: 8.85,
			transform: "rotate(10.62 223.74 239.02)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M230 259.06q-1.02 0-2.04-.19L212.58 256a11 11 0 0 1-7-4.57 11 11 0 0 1-1.72-8.18l2.88-15.38a11 11 0 0 1 4.57-7 11 11 0 0 1 8.18-1.73l15.38 2.89c2.87.54 5.35 2.16 7 4.57a11 11 0 0 1 1.72 8.18l-2.88 15.38a11 11 0 0 1-4.57 7 11 11 0 0 1-6.14 1.91Zm-1.28-4.27a6.73 6.73 0 0 0 7.9-5.41l2.89-15.38a6.73 6.73 0 0 0-5.4-7.9l-15.38-2.88a6.7 6.7 0 0 0-5.08 1.06 6.7 6.7 0 0 0-2.83 4.34L207.94 244a6.73 6.73 0 0 0 5.4 7.9z"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 166.92,
			height: 213.14,
			x: 66.61,
			y: 51.29,
			fill: "var(--card)",
			rx: 20.44,
			ry: 20.44,
			transform: "rotate(10.62 150.07 157.87)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M196.18 276.65q-2.1 0-4.2-.39L68.1 253.04a22.4 22.4 0 0 1-14.43-9.42 22.4 22.4 0 0 1-3.55-16.86L81.86 57.44a22.4 22.4 0 0 1 9.42-14.43 22.4 22.4 0 0 1 16.86-3.55l123.89 23.23a22.4 22.4 0 0 1 14.43 9.41 22.4 22.4 0 0 1 3.55 16.87l-31.74 169.31a22.4 22.4 0 0 1-9.42 14.43 22.4 22.4 0 0 1-12.67 3.94M103.96 43.23c-3.67 0-7.24 1.1-10.33 3.2a18.2 18.2 0 0 0-7.68 11.78L54.2 227.52c-.9 4.82.12 9.7 2.89 13.76a18.2 18.2 0 0 0 11.77 7.67l123.88 23.23c4.82.9 9.7-.12 13.76-2.9a18.3 18.3 0 0 0 7.67-11.76L245.93 88.2c.9-4.82-.13-9.7-2.9-13.75a18.2 18.2 0 0 0-11.77-7.68L107.38 43.55a19 19 0 0 0-3.42-.32M72.95 65.46l19.5 3.66"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M92.46 73.81a5 5 0 0 1-.87-.08l-19.5-3.66a4.7 4.7 0 1 1 1.73-9.22l19.5 3.65a4.7 4.7 0 0 1-.86 9.31m-26.08 26.68 19.5 3.66m.01 4.69a5 5 0 0 1-.87-.08l-19.5-3.66a4.7 4.7 0 1 1 1.73-9.22l19.5 3.65a4.7 4.7 0 0 1-.86 9.3Zm-26.07 26.68 19.5 3.66m0 4.69a5 5 0 0 1-.87-.08l-19.5-3.66a4.7 4.7 0 1 1 1.73-9.22l19.5 3.65a4.7 4.7 0 0 1-.86 9.3Zm-26.07 26.68 19.5 3.65m.01 4.7a5 5 0 0 1-.87-.09l-19.5-3.65a4.7 4.7 0 1 1 1.72-9.22l19.5 3.65a4.7 4.7 0 0 1-.85 9.3Zm-26.08 26.68 19.5 3.65m.01 4.7a5 5 0 0 1-.87-.09l-19.5-3.65a4.7 4.7 0 1 1 1.73-9.23l19.5 3.66a4.7 4.7 0 0 1-.86 9.3Zm84.31-8.15a53 53 0 0 0 38.18-7.26 53.3 53.3 0 0 0-18.53-97.55l-6.44-1.2-19.65 104.8z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M160.38 208.78q-5.13 0-10.26-.96l-8.48-1.6 20.41-108.88 8.48 1.6a55.46 55.46 0 0 1 44.24 64.64 55.6 55.6 0 0 1-24.98 36.7 55 55 0 0 1-29.4 8.5m-13.9-5.87 4.4.83a51 51 0 0 0 36.7-6.97 51.4 51.4 0 0 0 23.1-33.95 51.3 51.3 0 0 0-40.91-59.8l-4.4-.83z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--card)",
			d: "M206.29 162a53.2 53.2 0 0 1-24.05 35.32 53 53 0 0 1-38.18 7.25 53.2 53.2 0 0 1-34.78-23.2 53.31 53.31 0 1 1 97-19.38Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M153.94 207.57a56 56 0 0 1-10.26-.96 55 55 0 0 1-36.14-24.1 55 55 0 0 1-8.1-40.55 55.45 55.45 0 0 1 64.65-44.24 55 55 0 0 1 35.51 23.17 55 55 0 0 1 8.73 41.49 55.6 55.6 0 0 1-24.99 36.7 55 55 0 0 1-29.4 8.49m-.07-106.65a51.3 51.3 0 0 0-50.34 41.8 51 51 0 0 0 7.49 37.51 50.8 50.8 0 0 0 33.42 22.3 51 51 0 0 0 36.7-6.97 51.4 51.4 0 0 0 23.1-33.95c2.53-13.46-.34-27.09-8.07-38.38s-19.39-18.9-32.84-21.42q-4.78-.9-9.47-.89Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M166.36 162.53a24.14 24.14 0 1 0-30.33-5.69 37.6 37.6 0 0 0-26.75 24.53 53.2 53.2 0 0 0 34.78 23.2 53 53 0 0 0 38.18-7.25 37.6 37.6 0 0 0-15.88-34.79"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 216.42,
			cy: 248.64,
			r: 42.83,
			fill: "var(--foreground)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M216.35 293.55a44.6 44.6 0 0 1-29.06-10.74 44.95 44.95 0 0 1-5.04-63.3 44.95 44.95 0 0 1 63.3-5.04 44.95 44.95 0 0 1 5.04 63.3 44.6 44.6 0 0 1-34.24 15.78m.1-85.64a40.7 40.7 0 0 0-31.04 14.3 40.8 40.8 0 0 0 4.57 57.44 40.5 40.5 0 0 0 29.67 9.61 40.5 40.5 0 0 0 27.78-14.18 40.8 40.8 0 0 0-4.57-57.44 40.6 40.6 0 0 0-26.41-9.73"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 211.6,
			cy: 248.4,
			r: 42.83,
			fill: "var(--card)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M211.57 293.28a44.7 44.7 0 0 1-29.1-10.71 44.6 44.6 0 0 1-15.63-30.6 44.6 44.6 0 0 1 10.6-32.7 44.6 44.6 0 0 1 30.6-15.63 44.6 44.6 0 0 1 32.7 10.59 44.6 44.6 0 0 1 15.62 30.6 44.6 44.6 0 0 1-10.59 32.7 44.8 44.8 0 0 1-34.2 15.75m-26.4-13.87a40.8 40.8 0 0 0 57.44-4.58 40.5 40.5 0 0 0 9.61-29.66 40.5 40.5 0 0 0-14.18-27.78 40.5 40.5 0 0 0-29.67-9.61 40.5 40.5 0 0 0-27.77 14.18 40.5 40.5 0 0 0-9.62 29.67 40.5 40.5 0 0 0 14.19 27.78"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M211.6 277.83a5.36 5.36 0 0 1-5.35-5.36v-48.14a5.36 5.36 0 0 1 10.71 0v48.14c0 2.96-2.4 5.36-5.36 5.36"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M235.67 253.76h-48.14a5.36 5.36 0 1 1 0-10.72h48.14a5.36 5.36 0 1 1 0 10.72"
		})
	]
});
export default SvgEmptyCompany;
